import { DataGrid } from '@ijoin/components';
import { useListBuckets } from '@ijoin/hooks';
import { Stack, Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { LinkButton } from '../../components';

type Bucket = {
  creationDate?: string;
  name: string;
};

const S3BucketsPage = () => {
  const buckets = useListBuckets();

  const columns: GridColDef<Bucket>[] = [
    {
      field: 'name',
      flex: 2,
      headerName: 'Name',
      renderCell: params => (
        <LinkButton
          params={{ bucket: params.value }}
          search={{ prefix: '' }}
          to='/s3-browser/$bucket'
          variant='text'>
          {params.value}
        </LinkButton>
      )
    },
    {
      field: 'creationDate',
      flex: 1,
      headerName: 'Created',
      valueFormatter: value => (value ? new Date(value).toLocaleString() : '-')
    }
  ];

  return (
    <Stack spacing={2} sx={{ height: '100%', p: 2 }}>
      <Typography variant='h5'>S3 Buckets</Typography>

      <DataGrid
        autoHeight={false}
        columns={columns}
        disableColumnMenu
        disableRowSelectionOnClick
        getRowId={row => row.name}
        hideFooterPagination
        initialState={{
          sorting: { sortModel: [{ field: 'name', sort: 'asc' }] }
        }}
        loading={buckets.isFetching}
        rows={buckets.data?.data ?? []}
        showColumnMenu
        slotProps={{
          root: { 'data-testid': 's3-buckets' }
        }}
        sx={{ flex: 1, minHeight: 0 }}
      />
    </Stack>
  );
};

export const Route = createFileRoute('/s3-browser/')({
  beforeLoad: () => {
    if (localStorage.getItem('isAdmin') !== '1') {
      throw redirect({ to: '/organizations' });
    }
  },
  component: S3BucketsPage
});
